module.exports = __webpack_public_path__ + "img/no_address.fa1bbc06.png";